import axios from "axios";
import apiRoutes from "./apiRoutes";

const API = axios.create({
    baseURL: apiRoutes.BASE_URL,
    withCredentials: true,
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const register = (data) => API.post(apiRoutes.auth.register, data);
export const login = (data) => API.post(apiRoutes.auth.login, data);
export const getUserInfo = () => API.get(apiRoutes.user.info);
export const searchUsers = (query) => API.get(`${apiRoutes.user.search}?query=${query}`);
export const addContact = (contactUsername) =>
    API.post(apiRoutes.user.addContact, { contact_username: contactUsername });
export const getIncomingRequests = () => API.get(apiRoutes.user.incomingRequests);
export const getAssignableUsers = () => API.get(apiRoutes.user.assignableUsers);
export const getEmployeesPresence = () => API.get(apiRoutes.user.employees);
export const pingPresence = () => API.post(apiRoutes.user.presencePing);
export const removeContact = (contactUsername) =>
    API.delete(`${apiRoutes.user.removeContact}?contact_username=${contactUsername}`);
export const getPendingUsers = () => API.get(apiRoutes.admin.pendingUsers);
export const approveUser = (userId) => API.post(apiRoutes.admin.approveUser(userId));
export const logout = () => API.get(apiRoutes.auth.logout);
export const refreshToken = () => API.post(apiRoutes.auth.refreshToken);
export const getGoogleAuthStatus = () => API.get(apiRoutes.auth.googleStatus);
export const getCrmSummary = () => API.get(apiRoutes.crm.summary, { baseURL: apiRoutes.CRM_URL });
export const getCrmReports = (params = {}) => API.get(apiRoutes.crm.reports, { baseURL: apiRoutes.CRM_URL, params });
export const searchCrm = (params = {}) => API.get(apiRoutes.crm.search, { baseURL: apiRoutes.CRM_URL, params });
export const getCrmCompanies = (params = {}) => API.get(apiRoutes.crm.companies, { baseURL: apiRoutes.CRM_URL, params });
export const createCrmCompany = (data) => API.post(apiRoutes.crm.companies, data, { baseURL: apiRoutes.CRM_URL });
export const editCrmCompany = (companyId, data) =>
    API.put(apiRoutes.crm.companyDetails(companyId), data, { baseURL: apiRoutes.CRM_URL });
export const getCrmCompanyTimeline = (companyId, params = {}) =>
    API.get(apiRoutes.crm.companyTimeline(companyId), { baseURL: apiRoutes.CRM_URL, params });
export const archiveCrmCompany = (companyId, archived = true) =>
    API.post(apiRoutes.crm.companyArchive(companyId), { archived }, { baseURL: apiRoutes.CRM_URL });
export const deleteCrmCompany = (companyId) =>
    API.delete(apiRoutes.crm.companyDetails(companyId), { baseURL: apiRoutes.CRM_URL });
export const getCrmContacts = (params = {}) => API.get(apiRoutes.crm.contacts, { baseURL: apiRoutes.CRM_URL, params });
export const createCrmContact = (data) => API.post(apiRoutes.crm.contacts, data, { baseURL: apiRoutes.CRM_URL });
export const editCrmContact = (contactId, data) =>
    API.put(apiRoutes.crm.contactDetails(contactId), data, { baseURL: apiRoutes.CRM_URL });
export const archiveCrmContact = (contactId, archived = true) =>
    API.post(apiRoutes.crm.contactArchive(contactId), { archived }, { baseURL: apiRoutes.CRM_URL });
export const deleteCrmContact = (contactId) =>
    API.delete(apiRoutes.crm.contactDetails(contactId), { baseURL: apiRoutes.CRM_URL });
export const getCrmActivities = (params = {}) => API.get(apiRoutes.crm.activities, { baseURL: apiRoutes.CRM_URL, params });
export const createCrmActivity = (data) => API.post(apiRoutes.crm.activities, data, { baseURL: apiRoutes.CRM_URL });
export const editCrmActivity = (activityId, data) =>
    API.put(apiRoutes.crm.activityDetails(activityId), data, { baseURL: apiRoutes.CRM_URL });
export const archiveCrmActivity = (activityId, archived = true) =>
    API.post(apiRoutes.crm.activityArchive(activityId), { archived }, { baseURL: apiRoutes.CRM_URL });
export const deleteCrmActivity = (activityId) =>
    API.delete(apiRoutes.crm.activityDetails(activityId), { baseURL: apiRoutes.CRM_URL });
export const getCrmLeads = (params = {}) => API.get(apiRoutes.crm.leads, { baseURL: apiRoutes.CRM_URL, params });
export const createCrmLead = (data) => API.post(apiRoutes.crm.leads, data, { baseURL: apiRoutes.CRM_URL });
export const editCrmLead = (leadId, data) =>
    API.put(apiRoutes.crm.leadDetails(leadId), data, { baseURL: apiRoutes.CRM_URL });
export const convertCrmLead = (leadId, data = {}) =>
    API.post(apiRoutes.crm.leadConvert(leadId), data, { baseURL: apiRoutes.CRM_URL });
export const archiveCrmLead = (leadId, archived = true) =>
    API.post(apiRoutes.crm.leadArchive(leadId), { archived }, { baseURL: apiRoutes.CRM_URL });
export const deleteCrmLead = (leadId) =>
    API.delete(apiRoutes.crm.leadDetails(leadId), { baseURL: apiRoutes.CRM_URL });
export const updateAzsRequestStatus = (publicNumber, data) =>
    API.post(apiRoutes.crm.azsRequestStatus(publicNumber), data, { baseURL: apiRoutes.CRM_URL });
export const getCrmDeals = (params = {}) => API.get(apiRoutes.crm.deals, { baseURL: apiRoutes.CRM_URL, params });
export const createCrmDeal = (data) => API.post(apiRoutes.crm.deals, data, { baseURL: apiRoutes.CRM_URL });
export const editCrmDeal = (dealId, data) =>
    API.put(apiRoutes.crm.dealDetails(dealId), data, { baseURL: apiRoutes.CRM_URL });
export const archiveCrmDeal = (dealId, archived = true) =>
    API.post(apiRoutes.crm.dealArchive(dealId), { archived }, { baseURL: apiRoutes.CRM_URL });
export const deleteCrmDeal = (dealId) =>
    API.delete(apiRoutes.crm.dealDetails(dealId), { baseURL: apiRoutes.CRM_URL });
export const getCrmTasks = (params = {}) => API.get(apiRoutes.crm.tasks, { baseURL: apiRoutes.CRM_URL, params });
export const createCrmTask = (data) => API.post(apiRoutes.crm.tasks, data, { baseURL: apiRoutes.CRM_URL });
export const editCrmTask = (taskId, data) =>
    API.put(apiRoutes.crm.taskDetails(taskId), data, { baseURL: apiRoutes.CRM_URL });
export const archiveCrmTask = (taskId, archived = true) =>
    API.post(apiRoutes.crm.taskArchive(taskId), { archived }, { baseURL: apiRoutes.CRM_URL });
export const updateCrmTaskStatus = (taskId, status) =>
    API.post(apiRoutes.crm.taskStatus(taskId), { status }, { baseURL: apiRoutes.CRM_URL });
export const deleteCrmTask = (taskId) =>
    API.delete(apiRoutes.crm.taskDetails(taskId), { baseURL: apiRoutes.CRM_URL });
export const getCrmRecordAttachments = (entityType, entityId) =>
    API.get(apiRoutes.crm.recordAttachments(entityType, entityId), { baseURL: apiRoutes.CRM_URL });
export const uploadCrmRecordAttachment = (entityType, entityId, file) => {
    const data = new FormData();
    data.append("upload", file);
    return API.post(apiRoutes.crm.recordAttachments(entityType, entityId), data, {
        baseURL: apiRoutes.CRM_URL,
    });
};
export const deleteCrmRecordAttachment = (entityType, entityId, attachmentId) =>
    API.delete(apiRoutes.crm.recordAttachment(entityType, entityId, attachmentId), { baseURL: apiRoutes.CRM_URL });
export const getCrmRecordAttachmentDownloadUrl = (entityType, entityId, attachmentId) =>
    `${apiRoutes.CRM_URL}${apiRoutes.crm.recordAttachmentDownload(entityType, entityId, attachmentId)}`;
export const getCrmSiteTasks = (params = {}) => API.get(apiRoutes.crm.siteTasks, { baseURL: apiRoutes.CRM_URL, params });
export const getCrmSiteTaskCounters = () => API.get(apiRoutes.crm.siteTaskCounters, { baseURL: apiRoutes.CRM_URL });
export const createCrmSiteTask = (data) => API.post(apiRoutes.crm.siteTasks, data, { baseURL: apiRoutes.CRM_URL });
export const editCrmSiteTask = (taskId, data) =>
    API.put(apiRoutes.crm.siteTask(taskId), data, { baseURL: apiRoutes.CRM_URL });
export const archiveCrmSiteTask = (taskId, archived = true) =>
    API.post(apiRoutes.crm.siteTaskArchive(taskId), { archived }, { baseURL: apiRoutes.CRM_URL });
export const updateCrmSiteTaskStatus = (taskId, status) =>
    API.post(apiRoutes.crm.siteTaskStatus(taskId), { status }, { baseURL: apiRoutes.CRM_URL });
export const updateCrmSiteTaskChecklist = (taskId, checklist) =>
    API.post(apiRoutes.crm.siteTaskChecklist(taskId), { checklist }, { baseURL: apiRoutes.CRM_URL });
export const getCrmSiteTaskComments = (taskId) =>
    API.get(apiRoutes.crm.siteTaskComments(taskId), { baseURL: apiRoutes.CRM_URL });
export const createCrmSiteTaskComment = (taskId, body) =>
    API.post(apiRoutes.crm.siteTaskComments(taskId), { body }, { baseURL: apiRoutes.CRM_URL });
export const getCrmSiteTaskEvents = (taskId) =>
    API.get(apiRoutes.crm.siteTaskEvents(taskId), { baseURL: apiRoutes.CRM_URL });
export const getCrmSiteTaskAttachments = (taskId) =>
    API.get(apiRoutes.crm.siteTaskAttachments(taskId), { baseURL: apiRoutes.CRM_URL });
export const uploadCrmSiteTaskAttachment = (taskId, file) => {
    const data = new FormData();
    data.append("upload", file);
    return API.post(apiRoutes.crm.siteTaskAttachments(taskId), data, {
        baseURL: apiRoutes.CRM_URL,
    });
};
export const deleteCrmSiteTaskAttachment = (taskId, attachmentId) =>
    API.delete(apiRoutes.crm.siteTaskAttachment(taskId, attachmentId), { baseURL: apiRoutes.CRM_URL });
export const getCrmSiteTaskAttachmentDownloadUrl = (taskId, attachmentId) =>
    `${apiRoutes.CRM_URL}${apiRoutes.crm.siteTaskAttachmentDownload(taskId, attachmentId)}`;
export const getPriceMonitorProducts = (params = {}) =>
    API.get(apiRoutes.crm.priceMonitorProducts, { baseURL: apiRoutes.CRM_URL, params });
export const updatePriceMonitorProduct = (productCode, data) =>
    API.put(apiRoutes.crm.priceMonitorProduct(productCode), data, { baseURL: apiRoutes.CRM_URL });
export const updatePriceMonitorFavorite = (productCode, isFavorite) =>
    API.put(apiRoutes.crm.priceMonitorFavorite(productCode), { is_favorite: isFavorite }, { baseURL: apiRoutes.CRM_URL });
export const refreshPriceMonitorOwnPrice = (productCode) =>
    API.post(apiRoutes.crm.priceMonitorOwnPriceRefresh(productCode), {}, { baseURL: apiRoutes.CRM_URL });
export const refreshPriceMonitorOwnPricesAll = (favoriteOnly = false) =>
    API.post(apiRoutes.crm.priceMonitorOwnPricesRefreshAll, {}, { baseURL: apiRoutes.CRM_URL, params: { favorite_only: favoriteOnly } });
export const getPriceMonitorOwnPricesRefreshStatus = (favoriteOnly = false) =>
    API.get(apiRoutes.crm.priceMonitorOwnPricesRefreshStatus, { baseURL: apiRoutes.CRM_URL, params: { favorite_only: favoriteOnly } });
export const updatePriceMonitorCompetitor = (productCode, competitorName, data) =>
    API.put(apiRoutes.crm.priceMonitorCompetitor(productCode, competitorName), data, { baseURL: apiRoutes.CRM_URL });
export const updatePriceMonitorCompetitorVerification = (productCode, competitorName, data) =>
    API.put(apiRoutes.crm.priceMonitorCompetitorVerification(productCode, competitorName), data, { baseURL: apiRoutes.CRM_URL });
export const updatePriceMonitorDifferenceReview = (productCode, competitorName, data) =>
    API.put(apiRoutes.crm.priceMonitorDifferenceReview(productCode, competitorName), data, { baseURL: apiRoutes.CRM_URL });
export const refreshPriceMonitorCompetitor = (productCode, competitorName) =>
    API.post(apiRoutes.crm.priceMonitorCompetitorRefresh(productCode, competitorName), {}, { baseURL: apiRoutes.CRM_URL });
export const refreshPriceMonitorCompetitorAll = (competitorName, favoriteOnly = false) =>
    API.post(apiRoutes.crm.priceMonitorCompetitorRefreshAll(competitorName), {}, { baseURL: apiRoutes.CRM_URL, params: { favorite_only: favoriteOnly } });
export const getPriceMonitorCompetitorRefreshStatus = (competitorName, favoriteOnly = false) =>
    API.get(apiRoutes.crm.priceMonitorCompetitorRefreshStatus(competitorName), { baseURL: apiRoutes.CRM_URL, params: { favorite_only: favoriteOnly } });
export const getPriceMonitorCompetitorFeedUrl = (competitorName) =>
    `${apiRoutes.CRM_URL}${apiRoutes.crm.priceMonitorCompetitorFeed(competitorName)}`;
export const getPriceMonitorConfigExportUrl = () =>
    `${apiRoutes.CRM_URL}${apiRoutes.crm.priceMonitorConfigExport}`;
export const downloadPriceMonitorConfig = () =>
    API.get(apiRoutes.crm.priceMonitorConfigExport, {
        baseURL: apiRoutes.CRM_URL,
        responseType: "blob",
    });
export const importPriceMonitorConfig = (file) => {
    const data = new FormData();
    data.append("upload", file);
    return API.post(apiRoutes.crm.priceMonitorConfigImport, data, { baseURL: apiRoutes.CRM_URL });
};
export const downloadPriceMonitorExcel = () =>
    API.get(apiRoutes.crm.priceMonitorExcelExport, {
        baseURL: apiRoutes.CRM_URL,
        responseType: "blob",
    });
export const importPriceMonitorExcel = (file) => {
    const data = new FormData();
    data.append("upload", file);
    return API.post(apiRoutes.crm.priceMonitorExcelImport, data, { baseURL: apiRoutes.CRM_URL });
};
export const importPriceMonitorFeed = ({ sourceUrl = "", importTarget = "own", competitorName = "", file = null } = {}) => {
    const data = new FormData();
    data.append("source_url", sourceUrl);
    data.append("import_target", importTarget);
    data.append("competitor_name", competitorName);
    if (file) {
        data.append("upload", file);
    }
    return API.post(apiRoutes.crm.priceMonitorImport, data, { baseURL: apiRoutes.CRM_URL });
};
export const importCatalogYml = (data = {}) =>
    API.post(apiRoutes.crm.catalogImportYml, data, { baseURL: apiRoutes.CRM_URL });
export const getCatalogImportRuns = (params = {}) =>
    API.get(apiRoutes.crm.catalogImportRuns, { baseURL: apiRoutes.CRM_URL, params });
export const searchCatalogProducts = (params = {}) =>
    API.get(apiRoutes.crm.catalogProductSearch, { baseURL: apiRoutes.CRM_URL, params });
export const getIceServers = () => API.get(apiRoutes.chat.iceServers);
export const startContactCall = (callee) => API.post(apiRoutes.chat.calls, { callee });
export const getCallLogs = (params = {}) => API.get(apiRoutes.chat.callLogs, { params });
export const getIncomingCalls = () => API.get(apiRoutes.chat.incomingCalls);
export const getContactCall = (callId) => API.get(apiRoutes.chat.callDetails(callId));
export const acceptContactCall = (callId) => API.post(apiRoutes.chat.acceptCall(callId));
export const declineContactCall = (callId) => API.post(apiRoutes.chat.declineCall(callId));
export const startGroupCall = (participants, title = "") =>
    API.post(apiRoutes.chat.groupCalls, { participants, title });
export const getIncomingGroupCalls = () => API.get(apiRoutes.chat.incomingGroupCalls);
export const getGroupCall = (groupCallId) => API.get(apiRoutes.chat.groupCallDetails(groupCallId));
export const joinGroupCall = (groupCallId) => API.post(apiRoutes.chat.joinGroupCall(groupCallId));
export const declineGroupCall = (groupCallId) => API.post(apiRoutes.chat.declineGroupCall(groupCallId));
export const leaveGroupCall = (groupCallId) => API.post(apiRoutes.chat.leaveGroupCall(groupCallId));

export default API;
